function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shadow-svg",
  fill: "#FFFFFF",
  d: "M94.7,368.1c229.4-0.7,1010.8-15.2,1277.5-3.6c23,1-3,19-28,20c-135.7,5.4-451.1,11.1-726,10 c-173.4-0.7-369.2,27.4-536-6C32.1,378.5,5,368.4,94.7,368.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "mountain-svg",
  opacity: 0.52,
  fill: "#E4EDF4",
  d: "M283.1,365.3c0,0-0.9-320,153.6-323s163.4,213.3,284.1,213.3s135-126.2,175.8-150.2 c24-14.1,78.1-22.5,108.3,49.6s67.5,202.8,117.2,210.3H283.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M1132.2,326.5c0,0,43.5,1.5,58.7-13.7c15.2-15.2,22.2-25.7,17.5-37.4c-4.7-11.7-24.5-1.2-31.5-4.7 c-7-3.5-14-17.5,7-25.7c21-8.2,32.7-21,19.9-25.7c-12.9-4.7-24.5-2.3-4.7-18.7s21-39.7,7-42.1c-14-2.3-36.2,44.4-40.9,43.2 c-4.7-1.2-17.5-23.4-25.7-3.5c-8.2,19.9,8.2,60.8-12.9,47.9c-21-12.9-47.9-26.9-46.7,3.5C1081.9,301.2,1132.2,326.5,1132.2,326.5z "
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M1124.3,374.8c0.7-10,2-19.9,3.4-29.9c1.5-9.9,3.2-19.8,5.2-29.6c2-9.8,4.3-19.6,6.9-29.3 c2.6-9.7,5.5-19.3,8.7-28.8c3.3-9.5,6.9-18.9,10.9-28.1c4.1-9.2,8.6-18.2,13.8-26.9c5.2-8.6,11-16.9,17.8-24.4 c6.8-7.5,14.4-14.2,23.2-19.1c-8.3,5.7-15.4,12.7-21.7,20.4c-3.2,3.8-6.1,7.8-8.8,12c-2.7,4.1-5.3,8.4-7.8,12.7 c-4.8,8.7-9.2,17.6-13,26.8c-3.9,9.1-7.4,18.5-10.6,27.9c-3.3,9.4-6.1,19-8.8,28.6c-2.7,9.6-5.2,19.3-7.5,29 C1131.5,335.4,1127.6,355,1124.3,374.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M1146.5,187.8c1.3,4.1,2.6,8.2,3.7,12.3c1.2,4.1,2.3,8.2,3.4,12.4c1.1,4.1,2.2,8.3,3.2,12.4 c1.1,4.1,2,8.3,3,12.5l-2.4-1.5c4.7-1.3,9.4-2.4,14.1-3.7c4.7-1.2,9.4-2.3,14.2-3.4l7.1-1.6l7.1-1.5c4.8-1,9.5-1.9,14.4-2.7 c-4.6,1.7-9.2,3.2-13.8,4.7l-7,2.2l-7,2.1c-4.7,1.4-9.3,2.7-14,4c-4.7,1.3-9.4,2.6-14.1,3.8l0,0c-1,0.3-2.1-0.4-2.4-1.4 c0,0,0,0,0-0.1c-0.9-4.2-1.9-8.3-2.7-12.5c-0.9-4.2-1.7-8.4-2.5-12.6c-0.8-4.2-1.6-8.4-2.3-12.6 C1147.8,196.3,1147.1,192,1146.5,187.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M1108,234.5c2.8,5.8,5.4,11.7,8.1,17.5c2.6,5.9,5.2,11.8,7.7,17.7c2.6,5.9,5,11.8,7.5,17.8 c2.5,5.9,4.9,11.9,7.3,17.9l-2.5-1.1l19.4-6.4c6.5-2.1,13-4.2,19.5-6.2l9.8-3l9.8-2.9c6.6-1.9,13.1-3.8,19.7-5.6 c-6.3,2.6-12.7,5-19.1,7.5l-9.6,3.6l-9.6,3.5c-6.4,2.3-12.9,4.5-19.3,6.8l-19.4,6.6l0,0c-1,0.3-2.1-0.2-2.5-1.1 c-2.4-6-4.8-11.9-7.1-17.9c-2.3-6-4.6-12-6.9-18c-2.3-6-4.5-12.1-6.7-18.1C1112.1,246.7,1110,240.7,1108,234.5z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_10_)",
  d: "M879.3,338.1c0,0-45-7.4-46-27.3c-1-19.9,16.6-4.5,20.1-6.8c3.5-2.3-22.4-29-14.6-31 c7.8-2.1,10.9,7,11.7,1.6c0.8-5.3-15.4-24.4-6.2-28.8c9.2-4.3,8.4,7.2,10.3,1.4s-4.3-24,7.4-29.2c11.7-5.1,6.9,12.7,6.9,12.7 s-5.1,23.6-2.8,22c2.3-1.6,6-12.1,9-11.5c3.1,0.6,4.1,14.3-0.8,20.9c-4.9,6.6-2.5,8.5,7.6,5.2c10.1-3.3,10.9,6.6,5.1,16.2 c-5.8,9.7-8,17.2,2.5,10.3c10.5-7,19.1-7.6,16.8,7.6S897.2,320.3,879.3,338.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M883.6,341c-5.6-7.9-10-16.6-13.8-25.5c-1.9-4.5-3.5-9.1-5-13.7c-1.5-4.6-2.6-9.4-3.6-14.1 c-1.9-9.5-3-19.3-2.6-29.1c0.3-9.7,2.1-19.5,5.5-28.5c-1.8,9.5-2.6,19-2.3,28.5l0,1.8l0.1,1.8c0.1,1.2,0.1,2.4,0.2,3.6 c0.2,2.4,0.4,4.7,0.7,7.1c0.5,4.7,1.3,9.4,2.3,14.1c0.9,4.7,2.1,9.3,3.4,13.9c1.3,4.6,2.7,9.1,4.3,13.7 C875.9,323.4,879.5,332.3,883.6,341z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M887.1,305.7c-0.2,0.9-0.4,1.8-0.6,2.7c-0.3,0.8-0.6,1.7-1,2.6c-0.8,1.7-1.8,3.2-3,4.7 c-1.2,1.4-2.7,2.7-4.2,3.8c-0.8,0.5-1.6,1-2.5,1.5c-0.4,0.2-0.9,0.4-1.3,0.6c-0.5,0.2-0.9,0.3-1.5,0.5c-0.2,0-0.3,0.1-0.5,0.1 c-1.7-0.1-3.2-0.3-4.8-0.6c-1.6-0.3-3.1-0.7-4.6-1.3c-1.5-0.5-3-1.2-4.4-2c-1.4-0.8-2.7-1.7-3.9-2.8c1.6,0.4,3,0.8,4.5,1.1 c1.5,0.3,3,0.6,4.4,0.8c1.5,0.2,3,0.4,4.4,0.5c1.5,0.1,3,0.2,4.4,0.3l-0.5,0.1c0.2-0.1,0.7-0.2,1-0.4c0.4-0.1,0.7-0.3,1.1-0.5 c0.7-0.4,1.4-0.7,2.1-1.1c1.4-0.8,2.7-1.8,4-2.8c0.3-0.3,0.6-0.6,0.9-0.8c0.3-0.3,0.6-0.6,0.9-0.9l0.9-0.9l0.9-0.9 c0.6-0.6,1.1-1.3,1.7-2C886,307.1,886.5,306.4,887.1,305.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M876.4,278.4c-0.6,1.7-1.4,3.2-2.3,4.7c-0.9,1.5-1.8,2.9-2.8,4.3c-2,2.8-4.1,5.4-6.4,7.9l0,0 c-0.4,0.5-1,0.7-1.6,0.6c-0.9-0.1-1.7-0.2-2.5-0.3c-0.8-0.1-1.6-0.3-2.4-0.6c-1.6-0.4-3.1-1-4.5-1.8c-1.4-0.8-2.8-1.8-3.9-2.9 c-1.1-1.2-2-2.6-2.4-4.1c1.2,1.1,2.3,2,3.6,2.7c1.3,0.7,2.6,1.2,4,1.6c1.4,0.4,2.8,0.7,4.2,1c1.4,0.2,2.9,0.5,4.2,0.5l-1.6,0.7 c2.2-2.5,4.5-5,6.9-7.4c1.2-1.2,2.4-2.4,3.7-3.5C873.8,280.6,875.1,279.5,876.4,278.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M871.3,252.9c-0.3,1.9-1,3.6-1.7,5.3c-0.7,1.7-1.5,3.4-2.4,5c-1.7,3.3-3.6,6.4-5.6,9.5 c-0.6,0.9-1.8,1.2-2.7,0.6c-0.1-0.1-0.2-0.2-0.3-0.3c-1.4-1.4-2.6-2.9-3.9-4.4c-1.2-1.5-2.3-3.1-3.3-4.8c-1-1.7-1.9-3.4-2.6-5.3 c-0.7-1.8-1.3-3.8-1.1-5.8c0.7,1.8,1.7,3.3,2.8,4.8c1.1,1.5,2.2,2.9,3.5,4.3c1.2,1.4,2.4,2.8,3.7,4.2c1.2,1.4,2.5,2.8,3.8,4 l-3.1,0.3c2-3,4.1-6,6.3-9c1.1-1.5,2.2-2.9,3.3-4.4C869,255.8,870.2,254.4,871.3,252.9z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_11_)",
  d: "M889.9,326.8c0,0,30.2-5,30.9-18.3c0.7-13.4-11.2-3-13.5-4.5c-2.3-1.5,15-19.4,9.8-20.8 s-7.3,4.7-7.9,1.1s10.3-16.4,4.1-19.3s-5.6,4.8-6.9,1c-1.2-3.9,2.9-16.1-5-19.6c-7.9-3.4-4.6,8.5-4.6,8.5s3.4,15.8,1.9,14.7 c-1.5-1.1-4-8.1-6.1-7.7c-2.1,0.4-2.8,9.6,0.6,14s1.7,5.7-5.1,3.5s-7.3,4.4-3.4,10.9s5.4,11.6-1.7,6.9c-7-4.7-12.8-5.1-11.3,5.1 S877.9,314.8,889.9,326.8z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M887,328.7c2.5-6,4.8-12,6.8-18c2-6.1,3.7-12.2,4.9-18.4c0.7-3.1,1.2-6.2,1.6-9.4 c0.2-1.6,0.4-3.1,0.5-4.7c0.1-0.8,0.1-1.6,0.2-2.4c0.1-0.8,0.1-1.6,0.1-2.4c0.3-6.3-0.1-12.7-1.1-19.1c2.5,6,3.9,12.5,4.2,19.1 c0.2,3.3,0.1,6.6-0.2,9.9c-0.3,3.3-0.7,6.5-1.4,9.8c-1.3,6.4-3.4,12.7-6,18.7C894.1,317.8,891,323.5,887,328.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M884.6,305c0.9,0.9,1.7,1.8,2.5,2.5c0.8,0.8,1.7,1.5,2.5,2.2c0.9,0.7,1.8,1.2,2.7,1.7 c0.4,0.3,0.9,0.5,1.4,0.7c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.5,0.2,0.6,0.2l-0.5-0.1c0.9,0,1.9-0.1,2.8-0.1c1-0.1,2-0.1,2.9-0.2 c1-0.1,2-0.2,3-0.3c1-0.1,2-0.3,3.1-0.4c-0.7,0.8-1.6,1.6-2.5,2.2c-0.9,0.6-1.9,1.1-2.9,1.5c-1,0.4-2.1,0.7-3.1,1 c-1.1,0.2-2.1,0.4-3.3,0.5c-0.2,0-0.3,0-0.5-0.1l0,0c-0.5-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.3-0.9-0.4c-0.6-0.3-1.2-0.6-1.7-1 c-1.1-0.8-2.1-1.7-2.9-2.7c-0.8-1-1.5-2.1-1.9-3.3c-0.3-0.6-0.4-1.2-0.6-1.8C884.8,306.3,884.7,305.6,884.6,305z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M891.8,286.7c1,0.7,1.9,1.4,2.8,2.1c0.9,0.7,1.8,1.5,2.6,2.2c1.7,1.5,3.2,3.2,4.7,4.9l-1.6-0.7 c0.8,0,1.8-0.2,2.7-0.3c0.9-0.1,1.8-0.3,2.7-0.5c0.9-0.2,1.8-0.5,2.7-0.9c0.9-0.4,1.7-0.9,2.6-1.5c-0.2,1.1-0.7,2.1-1.4,3 c-0.7,0.9-1.7,1.6-2.6,2.2c-1,0.6-2,1-3.1,1.3c-0.5,0.2-1.1,0.3-1.6,0.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.6,0-1.2-0.2-1.5-0.6l0-0.1 c-1.5-1.7-3-3.5-4.2-5.4c-0.6-1-1.2-2-1.7-3C892.6,289,892,287.9,891.8,286.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M895.2,269.6l2.5,2.8c0.8,0.9,1.6,1.9,2.4,2.8c1.5,1.9,3,3.9,4.3,5.9l-3.1-0.3l2.5-2.7l2.5-2.7 c0.8-0.9,1.7-1.8,2.4-2.8c0.8-0.9,1.6-1.9,2.2-3.1c0.3,1.3-0.1,2.7-0.4,4c-0.4,1.3-1,2.5-1.6,3.7c-0.6,1.2-1.4,2.3-2.2,3.3 c-0.8,1-1.6,2-2.6,3c-0.8,0.8-2,0.8-2.8,0c-0.1-0.1-0.2-0.2-0.3-0.3c-1.3-2.1-2.6-4.2-3.6-6.5c-0.5-1.1-1-2.3-1.4-3.5 C895.7,272.1,895.3,270.9,895.2,269.6z"
}));

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#SVGID_12_)",
  points: "906.8,341.2 869,341.2 865.9,341.2 865.9,329.7 906.8,329.7  "
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#SVGID_13_)",
  points: "873.5,367.7 900,367.7 904.8,341.2 869,341.2  "
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#137277",
  d: "M912,128.3l6.5-4.8c0.7-0.4,1.5-0.4,2.2,0l100.4,59c0.7,0.4,1.1,1.1,1.1,1.9v219c0,0.8-0.5,1.6-1.2,1.9 l-8,4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#11A9BB",
  d: "M910.9,351.4l100.4,57.2c1.4,0.8,3.2-0.2,3.2-1.9l0.5-218c0-0.8-0.4-1.5-1.1-1.9l-99.8-58.2 c-1.4-0.8-3.3,0.2-3.3,1.9l-1.1,219C909.8,350.3,910.3,351,910.9,351.4z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#11A9BB",
  d: "M1018.5,258.7l1.3-0.7c0.6-0.3,1.3,0.1,1.3,0.8v44.3c0,1-0.5,1.9-1.3,2.4l-1,0.7c-0.4,0.3-1,0-1-0.5v-45.8 C1017.8,259.4,1018.1,259,1018.5,258.7z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#137277",
  d: "M968.4,369.2v8.5c0,1-1.1,1.7-2,1.2l-21.1-12c-0.4-0.2-0.7-0.7-0.7-1.2l0.5-8.8c0-1,1.1-1.7,2-1.2 l19.9,11.2C967.9,367.3,968.4,368.2,968.4,369.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M916.2,148.8l94.2,57.8c0.9,0.5,1.4,1.4,1.4,2.5l0.2,171.2c0,2.2-2.3,3.5-4.2,2.5l-90.5-50.7 c-3.3-1.9-5.4-5.4-5.4-9.3V151.2C912,149.1,914.3,147.7,916.2,148.8z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#137277",
  d: "M969,171.2c-1.6-1.1-14.6-8.7-14.6-8.7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#137277",
  d: "M922.9,147.4c0.1,1.5,1.1,2.4,2.3,2.1s2.1-1.6,2-2.8c-0.1-1.2-1.1-2.2-2.3-2.1 C923.7,144.7,922.8,145.9,922.9,147.4z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#137277",
  d: "M916.4,143.6c0.1,1.5,1.1,2.4,2.3,2.1c1.2-0.3,2.1-1.6,2-2.8c-0.1-1.2-1.1-2.2-2.3-2.1 S916.3,142.1,916.4,143.6z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2EBF2",
  d: "M917.6,175.4l87,53.5c1.8,1.1,4-0.2,4-2.3v-13.6c0-1.3-0.6-2.4-1.7-3.1l-86.6-53c-1.8-1.1-4,0.2-4,2.3V173 C916.4,174,916.8,174.9,917.6,175.4z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#B9C1C6",
  d: "M918.2,328.7l85.4,48.8c1.8,1,3.9-0.3,3.8-2.4l-0.4-13.2c0-1.2-0.7-2.3-1.7-2.9l-85.9-48.7 c-1.8-1-3.9,0.4-3.8,2.4l0.4,12.3C916,326.4,916.8,327.9,918.2,328.7z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2EBF2",
  d: "M965.2,220.7l37.2,21.4c1.1,0.6,2.4-0.2,2.4-1.4v-3.6c0-1.5-0.8-2.8-2.1-3.5l-36-20.5 c-1.1-0.6-2.4,0.2-2.4,1.4v4.8C964.4,219.9,964.7,220.4,965.2,220.7z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2EBF2",
  d: "M963.5,233.6l37.2,21.4c1.1,0.6,2.4-0.2,2.4-1.4v-5c0-0.6-0.3-1.1-0.8-1.4l-37.2-21.2 c-1.1-0.6-2.4,0.2-2.4,1.4v4.8C962.7,232.8,963,233.3,963.5,233.6z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2EBF2",
  d: "M920.4,277.5l29.9,17.2c0.9,0.5,1.9-0.1,1.9-1.1v-4c0-0.5-0.2-0.9-0.6-1.1l-29.9-17 c-0.9-0.5-1.9,0.1-1.9,1.1v3.8C919.8,276.9,920,277.3,920.4,277.5z"
});

var _ref25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M924.3,217.9l15.9,9.4c1.4,0.8,3-0.1,3-1.7v-18.7c0-1.3-0.7-2.5-1.8-3.1l-15.2-8.6 c-1.4-0.8-2.7,0.2-2.8,1.8l-0.2,19C923.1,216.8,923.5,217.6,924.3,217.9z"
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_2_)",
  d: "M942.3,227.3c0.7-0.6,0.7-1.5,0.7-2.5l-0.2-19.1c0-0.5-0.3-0.9-0.7-1.2c-3-1.8-15.1-8.7-16.1-9.2 c-0.7-0.4-1.5-0.2-1.9-0.1c0,0-0.1,0,0-0.1l3.4-2.2c0.2-0.1,0.4-0.3,0.7-0.3c0.7-0.3,1.5-0.2,2.1,0.1l0,0 c0.2,0.1,0.4,0.2,0.6,0.3l16,9.4c0.5,0.3,0.8,0.8,0.8,1.4l-0.3,19.1c0,0.5-0.3,0.9-0.7,1.2L942.3,227.3z"
});

var _ref27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M947.9,272.4l15.9,9.4c1.4,0.8,3-0.1,3-1.7v-18.7c0-1.3-0.7-2.5-1.8-3.1l-15.2-8.6 c-1.4-0.8-2.7,0.2-2.8,1.8l-0.2,19C946.8,271.3,947.2,272.1,947.9,272.4z"
}));

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_3_)",
  d: "M966,281.8c0.7-0.6,0.7-1.5,0.7-2.5l-0.2-19.1c0-0.5-0.3-0.9-0.7-1.2c-3-1.8-15.1-8.7-16.1-9.2 c-0.7-0.4-1.5-0.2-1.9-0.1c0,0-0.1,0,0-0.1l3.4-2.2c0.2-0.1,0.4-0.3,0.7-0.3c0.7-0.3,1.5-0.2,2.1,0.1l0,0 c0.2,0.1,0.4,0.2,0.6,0.3l16,9.4c0.5,0.3,0.8,0.8,0.8,1.4l-0.3,19.1c0,0.5-0.3,0.9-0.7,1.2L966,281.8z"
});

var _ref29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M920.5,257.3l15.9,9.4c1.4,0.8,3-0.1,3-1.7v-18.7c0-1.3-0.7-2.5-1.8-3.1l-15.2-8.6 c-1.4-0.8-2.7,0.2-2.8,1.8l-0.2,19C919.3,256.1,919.7,256.9,920.5,257.3z"
}));

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_4_)",
  d: "M938.5,266.7c0.7-0.6,0.7-1.5,0.7-2.5l-0.2-19.1c0-0.5-0.3-0.9-0.7-1.2c-3-1.8-15.1-8.7-16.1-9.2 c-0.7-0.4-1.5-0.2-1.9-0.1c0,0-0.1,0,0-0.1l3.4-2.2c0.2-0.1,0.4-0.3,0.7-0.3c0.7-0.3,1.5-0.2,2.1,0.1l0,0 c0.2,0.1,0.4,0.2,0.6,0.3l16,9.4c0.5,0.3,0.8,0.8,0.8,1.4l-0.3,19.1c0,0.5-0.3,0.9-0.7,1.2L938.5,266.7z"
});

var _ref31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M978.3,291.1l15.9,9.4c1.4,0.8,3-0.1,3-1.7v-18.7c0-1.3-0.7-2.5-1.8-3.1l-15.2-8.6 c-1.4-0.8-2.7,0.2-2.8,1.8l-0.2,19C977.1,290,977.5,290.7,978.3,291.1z"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_5_)",
  d: "M996.3,300.5c0.7-0.6,0.7-1.5,0.7-2.5l-0.2-19.1c0-0.5-0.3-0.9-0.7-1.2c-3-1.8-15.1-8.7-16.1-9.2 c-0.7-0.4-1.5-0.2-1.9-0.1c0,0-0.1,0,0-0.1l3.4-2.2c0.2-0.1,0.4-0.3,0.7-0.3c0.7-0.3,1.5-0.2,2.1,0.1l0,0 c0.2,0.1,0.4,0.2,0.6,0.3l16,9.4c0.5,0.3,0.8,0.8,0.8,1.4l-0.3,19.1c0,0.5-0.3,0.9-0.7,1.2L996.3,300.5z"
});

var _ref33 = /*#__PURE__*/React.createElement("g", {
  className: "phone-svg__msg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#913F02",
  d: "M985.5,332.8L957.2,316c-0.3-0.2-0.4-0.5-0.4-0.8l-2.6-24.5c0-0.7,3.4-1.6,4-1.3l0,0l41.5,23.9 c0.5,0.3,0.9,0.9,0.9,1.5v25.6c0,0.3-0.2,0.7-0.5,0.8l-1.7,1c-0.1,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.2,0-0.4,0l-0.4-0.1 c-1-0.3-0.9,0.5-1,1.2l-0.2,7.2c0,0.9-0.3,1.3-1.1,1.5l-0.5,0.1c-0.7,0.1-1.1,0.1-1.4-0.6l-6.4-17.9 C986.1,333.3,985.9,333,985.5,332.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC5C00",
  d: "M955.4,291l41.3,23.8c0.6,0.4,1,1,1,1.7v25.5c0,0.2-0.2,0.4-0.4,0.3l-2.9-1.3c-0.2-0.1-0.4,0.1-0.4,0.3 l-0.5,10.3c0,0.3-0.4,0.4-0.6,0.1l-9.4-17.1c0-0.1-0.1-0.1-0.1-0.1l-26.9-16c-1.4-0.8-2.3-2.3-2.3-4v-23.9c0-0.2,0.3-0.4,0.5-0.3 L955.4,291z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M961,309.7c0.2,2.4,1.6,3.6,3.2,2.8c1.5-0.8,2.7-2.9,2.5-4.7c-0.1-1.9-1.5-3.2-3.2-3 C961.9,305.1,960.8,307.3,961,309.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M971.2,315.8c0.2,2.4,1.6,3.6,3.2,2.8c1.5-0.8,2.7-2.9,2.5-4.7c-0.1-1.9-1.5-3.2-3.2-3 C972.1,311.1,971,313.3,971.2,315.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M982.2,321.5c0.2,2.4,1.6,3.6,3.2,2.8c1.5-0.8,2.7-2.9,2.5-4.7c-0.1-1.9-1.5-3.2-3.2-3 C983.1,316.9,982,319.1,982.2,321.5z"
}));

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_23_)",
  d: "M910.8,149.8l-87.4,91.7c-0.8,0.8-1.2,1.9-1.2,3.1l2.9,193c0,3,3,5,5.8,4.1 l178.2-57.4c1.8-0.6,3.1-2.3,3.1-4.2v-171c0-1.5-0.8-3-2.1-3.8l-94.1-56.3C914.3,148.1,912.1,148.4,910.8,149.8z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "phone-svg__shadow",
  fill: "#ccc",
  d: "M957.9,421.8c0,0-62.3-24-43.6-5.8c18.7,18.2,96.4,40.8,76.2,25.8C963.9,422.2,963,428.4,957.9,421.8z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_6_)",
  d: "M213.3,346.1c0,0-45-7.4-46-27.3c-1-19.9,16.6-4.5,20.1-6.8c3.5-2.3-22.4-29-14.6-31 s10.9,7,11.7,1.6c0.8-5.3-15.4-24.4-6.2-28.8s8.4,7.2,10.3,1.4c1.8-5.8-4.3-24,7.4-29.2c11.7-5.1,6.9,12.7,6.9,12.7 s-5.1,23.6-2.8,22c2.3-1.6,6-12.1,9-11.5s4.1,14.3-0.8,20.9c-4.9,6.6-2.5,8.5,7.6,5.2c10.1-3.3,10.9,6.6,5.1,16.2 s-8,17.2,2.5,10.3c10.5-7,19.1-7.6,16.8,7.6S231.2,328.3,213.3,346.1z"
});

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M217.6,349c-5.6-7.9-10-16.6-13.8-25.5c-1.9-4.5-3.5-9.1-5-13.7c-1.5-4.6-2.6-9.4-3.6-14.1 c-1.9-9.5-3-19.3-2.6-29.1c0.3-9.7,2.1-19.5,5.5-28.5c-1.8,9.5-2.6,19-2.3,28.5l0,1.8l0.1,1.8c0.1,1.2,0.1,2.4,0.2,3.6 c0.2,2.4,0.4,4.7,0.7,7.1c0.5,4.7,1.3,9.4,2.3,14.1c0.9,4.7,2.1,9.3,3.4,13.9c1.3,4.6,2.7,9.1,4.3,13.7 C209.9,331.4,213.5,340.3,217.6,349z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M221.1,313.7c-0.2,0.9-0.4,1.8-0.6,2.7c-0.3,0.8-0.6,1.7-1,2.6c-0.8,1.7-1.8,3.2-3,4.7 c-1.2,1.4-2.7,2.7-4.2,3.8c-0.8,0.5-1.6,1-2.5,1.5c-0.4,0.2-0.9,0.4-1.3,0.6c-0.5,0.2-0.9,0.3-1.5,0.5c-0.2,0-0.3,0.1-0.5,0.1 c-1.7-0.1-3.2-0.3-4.8-0.6c-1.6-0.3-3.1-0.7-4.6-1.3c-1.5-0.5-3-1.2-4.4-2c-1.4-0.8-2.7-1.7-3.9-2.8c1.6,0.4,3,0.8,4.5,1.1 c1.5,0.3,3,0.6,4.4,0.8c1.5,0.2,3,0.4,4.4,0.5c1.5,0.1,3,0.2,4.4,0.3l-0.5,0.1c0.2-0.1,0.7-0.2,1-0.4c0.4-0.1,0.7-0.3,1.1-0.5 c0.7-0.4,1.4-0.7,2.1-1.1c1.4-0.8,2.7-1.8,4-2.8c0.3-0.3,0.6-0.6,0.9-0.8c0.3-0.3,0.6-0.6,0.9-0.9l0.9-0.9l0.9-0.9 c0.6-0.6,1.1-1.3,1.7-2C220,315.1,220.5,314.4,221.1,313.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M210.4,286.4c-0.6,1.7-1.4,3.2-2.3,4.7c-0.9,1.5-1.8,2.9-2.8,4.3c-2,2.8-4.1,5.4-6.4,7.9l0,0 c-0.4,0.5-1,0.7-1.6,0.6c-0.9-0.1-1.7-0.2-2.5-0.3c-0.8-0.1-1.6-0.3-2.4-0.6c-1.6-0.4-3.1-1-4.5-1.8c-1.4-0.8-2.8-1.8-3.9-2.9 c-1.1-1.2-2-2.6-2.4-4.1c1.2,1.1,2.3,2,3.6,2.7c1.3,0.7,2.6,1.2,4,1.6c1.4,0.4,2.8,0.7,4.2,1c1.4,0.2,2.9,0.5,4.2,0.5l-1.6,0.7 c2.2-2.5,4.5-5,6.9-7.4c1.2-1.2,2.4-2.4,3.7-3.5C207.8,288.6,209.1,287.5,210.4,286.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M205.3,260.9c-0.3,1.9-1,3.6-1.7,5.3c-0.7,1.7-1.5,3.4-2.4,5c-1.7,3.3-3.6,6.4-5.6,9.5 c-0.6,0.9-1.8,1.2-2.7,0.6c-0.1-0.1-0.2-0.2-0.3-0.3c-1.4-1.4-2.6-2.9-3.9-4.4c-1.2-1.5-2.3-3.1-3.3-4.8c-1-1.7-1.9-3.4-2.6-5.3 c-0.7-1.8-1.3-3.8-1.1-5.8c0.7,1.8,1.7,3.3,2.8,4.8c1.1,1.5,2.2,2.9,3.5,4.3c1.2,1.4,2.4,2.8,3.7,4.2c1.2,1.4,2.5,2.8,3.8,4 l-3.1,0.3c2-3,4.1-6,6.3-9c1.1-1.5,2.2-2.9,3.3-4.4C203,263.8,204.2,262.4,205.3,260.9z"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_7_)",
  d: "M223.9,334.8c0,0,30.2-5,30.9-18.3c0.7-13.4-11.2-3-13.5-4.5c-2.3-1.5,15-19.4,9.8-20.8 s-7.3,4.7-7.9,1.1s10.3-16.4,4.1-19.3c-6.2-2.9-5.6,4.8-6.9,1c-1.2-3.9,2.9-16.1-5-19.6c-7.9-3.4-4.6,8.5-4.6,8.5 s3.4,15.8,1.9,14.7c-1.5-1.1-4-8.1-6.1-7.7c-2.1,0.4-2.8,9.6,0.6,14c3.3,4.4,1.7,5.7-5.1,3.5c-6.7-2.2-7.3,4.4-3.4,10.9 s5.4,11.6-1.7,6.9c-7-4.7-12.8-5.1-11.3,5.1C207.2,320.4,211.9,322.8,223.9,334.8z"
});

var _ref39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M221,336.7c2.5-6,4.8-12,6.8-18c2-6.1,3.7-12.2,4.9-18.4c0.7-3.1,1.2-6.2,1.6-9.4 c0.2-1.6,0.4-3.1,0.5-4.7c0.1-0.8,0.1-1.6,0.2-2.4c0.1-0.8,0.1-1.6,0.1-2.4c0.3-6.3-0.1-12.7-1.1-19.1c2.5,6,3.9,12.5,4.2,19.1 c0.2,3.3,0.1,6.6-0.2,9.9c-0.3,3.3-0.7,6.5-1.4,9.8c-1.3,6.4-3.4,12.7-6,18.7C228.1,325.8,225,331.5,221,336.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M218.6,313c0.9,0.9,1.7,1.8,2.5,2.5c0.8,0.8,1.7,1.5,2.5,2.2c0.9,0.7,1.7,1.2,2.7,1.7 c0.4,0.3,0.9,0.5,1.4,0.7c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.5,0.2,0.6,0.2l-0.5-0.1c0.9,0,1.9-0.1,2.8-0.1c1-0.1,2-0.1,2.9-0.2 c1-0.1,2-0.2,3-0.3c1-0.1,2-0.3,3.1-0.4c-0.7,0.8-1.6,1.6-2.5,2.2c-0.9,0.6-1.9,1.1-2.9,1.5c-1,0.4-2.1,0.7-3.1,1 c-1.1,0.2-2.1,0.4-3.3,0.5c-0.2,0-0.3,0-0.5-0.1l0,0c-0.5-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.3-0.9-0.4c-0.6-0.3-1.2-0.6-1.7-1 c-1.1-0.8-2.1-1.7-2.9-2.7c-0.8-1-1.5-2.1-1.9-3.3c-0.3-0.6-0.4-1.2-0.6-1.8C218.8,314.3,218.7,313.6,218.6,313z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M225.8,294.7c1,0.7,1.9,1.4,2.8,2.1c0.9,0.7,1.8,1.5,2.6,2.2c1.7,1.5,3.2,3.2,4.7,4.9l-1.6-0.7 c0.8,0,1.8-0.2,2.7-0.3c0.9-0.1,1.8-0.3,2.7-0.5c0.9-0.2,1.8-0.5,2.7-0.9c0.9-0.4,1.7-0.9,2.6-1.5c-0.2,1.1-0.7,2.1-1.4,3 c-0.7,0.9-1.7,1.6-2.6,2.2c-1,0.6-2,1-3.1,1.3c-0.5,0.2-1.1,0.3-1.6,0.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.6,0-1.2-0.2-1.5-0.6l0-0.1 c-1.5-1.7-3-3.5-4.2-5.4c-0.6-1-1.2-2-1.7-3C226.6,297,226,295.9,225.8,294.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0A564D",
  d: "M229.2,277.6l2.5,2.8c0.8,0.9,1.6,1.9,2.4,2.8c1.5,1.9,3,3.9,4.3,5.9l-3.1-0.3l2.5-2.7l2.5-2.7 c0.8-0.9,1.7-1.8,2.4-2.8c0.8-0.9,1.6-1.9,2.2-3.1c0.3,1.3-0.1,2.7-0.4,4c-0.4,1.3-1,2.5-1.6,3.7c-0.6,1.2-1.4,2.3-2.2,3.3 c-0.8,1-1.6,2-2.6,3c-0.8,0.8-2,0.8-2.8,0c-0.1-0.1-0.2-0.2-0.3-0.3c-1.3-2.1-2.6-4.2-3.6-6.5c-0.5-1.1-1-2.3-1.4-3.5 C229.7,280.1,229.3,278.9,229.2,277.6z"
}));

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#SVGID_8_)",
  points: "240.8,349.2 203,349.2 199.9,349.2 199.9,337.7 240.8,337.7  "
});

var _ref41 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#SVGID_9_)",
  points: "207.5,375.7 234,375.7 238.8,349.2 203,349.2  "
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_14_)",
  d: "M759.8,347c0,0-22.3,0.8-30.1-7s-11.4-13.2-9-19.2c2.4-6,12.6-0.6,16.2-2.4s7.2-9-3.6-13.2 c-10.8-4.2-16.8-10.8-10.2-13.2c6.6-2.4,12.6-1.2,2.4-9.6c-10.2-8.4-10.8-20.4-3.6-21.6c7.2-1.2,18.6,22.8,21,22.2 c2.4-0.6,9-12,13.2-1.8c4.2,10.2-4.2,31.2,6.6,24.6c10.8-6.6,24.6-13.8,24,1.8C785.6,334,759.8,347,759.8,347z"
});

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M763.9,371.8c-2.1-10.1-4.3-20.1-6.8-30c-1.3-4.9-2.5-9.9-4-14.8c-1.4-4.9-2.9-9.8-4.6-14.6 c-3.2-9.6-7.1-19-11.9-28c-2.4-4.4-5.1-8.7-8.2-12.7c-3.1-4-6.6-7.7-10.7-10.8c4.6,2.4,8.6,5.8,12.2,9.5c3.6,3.8,6.7,8,9.4,12.4 c2.8,4.4,5.1,9.1,7.3,13.8c2.1,4.7,4,9.6,5.7,14.5c3.3,9.8,5.9,19.8,7.8,30C762.1,351.2,763.5,361.5,763.9,371.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M752.5,275.9c-0.1,2.2-0.3,4.4-0.6,6.6c-0.3,2.2-0.5,4.4-0.9,6.5c-0.7,4.3-1.5,8.6-2.5,12.9 c-0.2,1.1-1.3,1.7-2.3,1.5l-0.1,0l0,0c-2.4-0.6-4.8-1.3-7.2-2c-2.4-0.7-4.8-1.4-7.1-2.2c-2.4-0.8-4.7-1.6-7.1-2.5 c-2.3-0.9-4.7-1.8-7-2.9c2.5,0.2,5,0.5,7.5,0.9c2.5,0.4,4.9,0.8,7.4,1.3c2.4,0.5,4.9,1,7.3,1.6c2.4,0.6,4.8,1.2,7.2,1.9l-2.4,1.5 c1-4.3,2.1-8.5,3.4-12.7c0.6-2.1,1.3-4.2,2-6.3C750.9,280,751.6,277.9,752.5,275.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M772.3,299.9c-0.8,3.2-1.8,6.4-2.8,9.5c-1,3.1-2,6.3-3.1,9.4c-1.1,3.1-2.2,6.2-3.4,9.3 c-1.1,3.1-2.3,6.2-3.6,9.2c-0.4,1-1.5,1.5-2.5,1.2l0,0c-3.3-1.1-6.6-2.2-9.9-3.4c-3.3-1.2-6.6-2.4-9.8-3.6l-4.9-1.9l-4.9-2 c-3.2-1.4-6.5-2.7-9.6-4.3c3.5,0.7,6.9,1.5,10.3,2.4l5.1,1.4l5.1,1.4c3.4,0.9,6.7,2,10.1,3c3.3,1.1,6.7,2.1,10,3.3l-2.5,1.1 c1.2-3.1,2.5-6.1,3.8-9.1c1.3-3,2.6-6.1,4-9.1c1.3-3,2.8-6,4.2-9C769.2,305.7,770.7,302.8,772.3,299.9z"
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_15_)",
  d: "M302.2,365.3c0,0-11.7-9-3.6-22.7s25.7-23.3,27.3-20.1s-4,11.3-5.6,14.5s-6.4,21.7-12.1,24.9 S302.2,365.3,302.2,365.3z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#09494C",
  d: "M301,374.8c-0.3-3.8-0.1-7.6,0.4-11.4c0.5-3.8,1.3-7.5,2.4-11.2c1.1-3.7,2.7-7.3,4.8-10.6 c1.1-1.6,2.3-3.2,3.7-4.6c1.4-1.3,3-2.5,4.8-3.2c-2.9,2.5-4.8,5.6-6.5,8.9c-1.6,3.3-2.8,6.8-3.9,10.3c-0.6,1.8-1.1,3.6-1.6,5.3 c-0.5,1.8-0.9,3.6-1.4,5.4L301,374.8z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_16_)",
  d: "M292.8,366.7c0,0,5.5-0.4,9.4-7c3-5.1,3.4-11.4,1.2-16.9c-1.4-3.5-2.5-8.2-0.1-11.5 c4-5.6,0.1-9.9-1.6-14.3c-1-2.5-2.4-4.8-4.1-6.9c-2.1-2.6-5.2-8.2-4.7-17.5c0.8-13.7-15.3-23.3-19.3-15.3 c-2.3,4.6-2,10.2-1.3,14.2c1,5.8,1.2,11.7,0.3,17.5c-0.8,4.8-3.6,8.2-4.6,10.9c-3.2,8,4.8,37.8,12.1,42.6S292.8,366.7,292.8,366.7 z"
});

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M278.4,275.1c3.5,16.4,6.7,33,9.4,49.5c0.7,4.1,1.4,8.3,2,12.5c0.6,4.2,1.2,8.3,1.7,12.5 c0.4,4.2,0.8,8.4,1,12.6c0.2,4.2,0.3,8.5-0.5,12.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0.3-2.1,0.3-4.2,0.2-6.3l-0.1-3.1l-0.2-3.1 c-0.3-4.2-0.8-8.3-1.3-12.5c-0.5-4.2-1-8.3-1.6-12.5c-0.6-4.2-1.2-8.3-1.8-12.5c-1.3-8.3-2.7-16.6-4.2-24.9 C281.4,291.6,279.9,283.3,278.4,275.1C278.3,275.1,278.3,275,278.4,275.1C278.3,275,278.4,275,278.4,275.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M289.6,281.7c-2.5,3-5.1,5.9-7.6,8.8c-0.1,0.1-0.3,0.2-0.4,0.1l0,0c-1.7-0.7-3.4-1.3-5-2.1 c-1.6-0.8-3.2-1.6-4.8-2.5c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.8,0.5,3.5,1.1,5.1,1.7c1.7,0.7,3.3,1.4,4.9,2.2l-0.5,0.1 C284,287.1,286.7,284.3,289.6,281.7C289.5,281.6,289.5,281.6,289.6,281.7C289.6,281.6,289.6,281.6,289.6,281.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M292.8,291.8c-2.9,3-5.9,5.9-8.8,8.8c-0.1,0.1-0.3,0.1-0.4,0.1l0,0c-1.8-0.6-3.7-1.1-5.4-1.8 c-1.8-0.7-3.6-1.4-5.3-2.3c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.9,0.4,3.7,0.9,5.6,1.5c1.8,0.6,3.6,1.3,5.4,2l-0.4,0.1 C286.5,297.2,289.6,294.5,292.8,291.8C292.8,291.7,292.8,291.7,292.8,291.8C292.9,291.8,292.9,291.8,292.8,291.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M293.9,303.1c-2.7,2.3-5.4,4.6-8.1,6.9c-0.1,0.1-0.2,0.1-0.3,0.1l0,0c-2.1-0.5-4.3-0.9-6.4-1.5 c-1.1-0.3-2.1-0.6-3.1-1c-1-0.4-2.1-0.7-3.1-1.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.1,0.1,2.2,0.3,3.3,0.5c1.1,0.2,2.1,0.4,3.2,0.7 c2.1,0.5,4.2,1.2,6.3,1.8l-0.3,0.1C288.2,307.3,291,305.2,293.9,303.1C293.8,303,293.9,303,293.9,303.1 C293.9,303.1,293.9,303.1,293.9,303.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M299.6,313.2c-3.9,2.6-7.8,5.2-11.8,7.8c-0.1,0.1-0.2,0.1-0.3,0l0,0l-4.3-1.3c-1.4-0.4-2.9-0.9-4.3-1.4 c-1.4-0.5-2.8-1-4.2-1.5c-1.4-0.6-2.8-1.1-4.2-1.7c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.5,0.3,2.9,0.7,4.4,1.1c1.4,0.4,2.9,0.8,4.3,1.3 c1.4,0.4,2.8,1,4.3,1.5l4.2,1.5l-0.3,0C291.4,317.9,295.5,315.5,299.6,313.2C299.5,313.1,299.6,313.1,299.6,313.2 C299.6,313.1,299.6,313.2,299.6,313.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M304,322.1l-14.3,10.4c-0.1,0.1-0.2,0.1-0.3,0.1l0,0l-5.6-1.2c-1.9-0.4-3.7-0.8-5.6-1.2 c-1.9-0.4-3.7-0.9-5.6-1.4c-1.8-0.5-3.7-1-5.5-1.6c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.9,0.3,3.8,0.6,5.7,1c1.9,0.4,3.8,0.7,5.6,1.1 c1.9,0.4,3.7,0.9,5.6,1.3l5.6,1.4l-0.3,0.1L304,322.1C304,322,304,322,304,322.1C304,322.1,304,322.1,304,322.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M302,338.2l-10.4,8.5c-0.1,0.1-0.2,0.1-0.3,0.1l0,0l-11.2-3.1c-1.9-0.6-3.7-1.2-5.5-1.8 c-1.8-0.6-3.7-1.3-5.5-2c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.9,0.4,3.8,0.8,5.7,1.3c1.9,0.5,3.7,1,5.6,1.5l11.1,3.5l-0.3,0.1 L302,338.2C302,338.1,302,338.1,302,338.2C302.1,338.1,302.1,338.1,302,338.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#823500",
  d: "M305,348.5c-4.3,3.5-8.5,7-12.8,10.5c-0.1,0.1-0.2,0.1-0.3,0.1l0,0c-3.2-1.1-6.4-2.1-9.5-3.3 c-1.6-0.6-3.1-1.2-4.7-1.8c-1.5-0.6-3.1-1.3-4.6-2c0,0,0,0,0-0.1c0,0,0,0,0.1,0c1.6,0.4,3.2,0.9,4.8,1.4c1.6,0.5,3.2,1,4.8,1.6 c3.2,1.1,6.3,2.4,9.4,3.5l-0.4,0.1C296.1,355,300.5,351.7,305,348.5C305,348.4,305,348.4,305,348.5 C305,348.4,305,348.5,305,348.5z"
}));

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_17_)",
  d: "M1136.4,347.8c0,0,0.8-14-9.1-18.1c-9.9-4.1-14-6.6-15.7-4.1c-1.6,2.5,4.9,19.8,10.7,22.2 S1133.1,354.4,1136.4,347.8z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_18_)",
  d: "M1149.4,326.5c0,0,6.9-6.9,8.5,3.1c1.5,10-4.6,28.4-11.5,21.5 C1139.5,344.2,1146.4,328.8,1149.4,326.5z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E8778",
  d: "M1157.9,368.8c0,0-3.1,0.8-3.8,2.3c-0.8,1.5-6.9,3.8-6.9-1.5c0-5.4,2.3-6.9,5.4-6.9 S1157.9,368.8,1157.9,368.8z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M1151.7,333.4c-1.4,9.3-3.1,18.4-4.6,27.6c-0.8,4.6-1.4,9.2-2,13.8c-0.5,4.6-1,9.2-1.1,13.9 c-0.8-4.6-0.7-9.4-0.5-14.1c0.1-2.4,0.4-4.7,0.6-7c0.3-2.3,0.6-4.7,1-7c0.8-4.6,1.7-9.2,2.7-13.8 C1149,342.4,1150.2,337.9,1151.7,333.4z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M1122.5,335c3.4,2.2,6.5,4.9,9.3,7.9c2.8,3,5.2,6.3,7.3,9.9c2,3.6,3.6,7.4,4.5,11.4 c0.9,4,1.2,8.2,0.6,12.2c-0.3-4-0.9-8-2.1-11.8c-0.6-1.9-1.3-3.8-2.1-5.6c-0.8-1.8-1.7-3.6-2.7-5.3c-1.9-3.5-4.2-6.7-6.7-9.8 C1128.2,340.7,1125.5,337.8,1122.5,335z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A5148",
  d: "M1155.6,365.7l-3.3,3.8c-1.1,1.2-2.1,2.5-3.1,3.8c-1,1.3-1.9,2.6-2.8,4c-0.9,1.4-1.6,2.8-2.4,4.3 c0-1.7,0.4-3.5,1.1-5.1c0.7-1.6,1.5-3.1,2.6-4.5c1.1-1.4,2.3-2.6,3.6-3.7C1152.5,367.3,1154,366.3,1155.6,365.7z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_19_)",
  d: "M1164.8,371.9c0,0,3.9-6.1-1.4-8.5c-5.4-2.4-11.5-2.4-13.8-0.2c0,0,6.9,1.6,8.4,5.5 C1159.4,372.6,1162.4,374.2,1164.8,371.9z"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  className: "leaf-orange"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CC5C00",
  d: "M1119.7,335c-0.4-1-1.7-1.2-2.3-0.4c-1.4,1.6-3.4,5-3.8,12.7c-0.8,12.3,2.3,16.1,2.3,16.1 S1123.3,344.3,1119.7,335z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC5C00",
  d: "M1101.4,311.1c-0.8-1-2.4-0.8-2.9,0.4c-1,2-2.1,5.6-1.1,10.4c1.5,7.7,7.7,30.7,10,30 C1109.5,351.1,1108.3,319.4,1101.4,311.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC5C00",
  d: "M1105.8,358c0,0-15.4-18.1-28-21.7c-1.1-0.3-2,0.8-1.4,1.8c2.4,4.2,8.3,12.6,18,16.1 C1107.3,358.8,1104.3,358.8,1105.8,358z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1107.3,351.1c1.2,2.2,2.2,4.4,3.2,6.6c1,2.2,1.9,4.4,2.9,6.6c0.5,1.1,1,2.2,1.6,3.1l0.2,0.3c0.1,0.1,0.1,0.1,0.2,0.2 l0.1,0.1c0,0,0.1,0.1,0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4c0.5,0.6,0.7,1.3,0.9,1.9c0.4,1.3,0.5,2.5,0.5,3.8c0,1.2,0,2.5-0.2,3.7 c-0.5-2.4-0.9-4.8-1.7-6.9c-0.2-0.5-0.5-1-0.8-1.3c-0.1-0.1-0.1-0.1-0.2-0.2l-0.4-0.3c-0.2-0.1-0.3-0.3-0.4-0.4l-0.3-0.4 c-0.8-1.1-1.3-2.2-1.8-3.3c-1-2.3-1.9-4.5-2.6-6.9C1108.3,355.9,1107.7,353.5,1107.3,351.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1115.8,362.6c0.4,0.7,0.6,1.3,0.7,2c0.1,0.6,0.2,1.3,0.2,1.9c0,0.6,0,1.3-0.1,1.9c-0.1,0.6-0.2,1.3-0.5,2 c-0.6-0.5-0.9-1.2-1.1-1.8c-0.2-0.7-0.3-1.3-0.3-2c0-0.7,0-1.3,0.2-2C1115.1,363.9,1115.3,363.2,1115.8,362.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1105,358c0.8-0.4,1.8-0.4,2.6-0.3c0.9,0.2,1.7,0.6,2.4,1.2c0.7,0.6,1.2,1.3,1.6,2.1c0.2,0.4,0.3,0.8,0.4,1.3 c0.1,0.4,0.1,0.9,0,1.3c-0.4-0.3-0.6-0.6-0.9-0.9c-0.3-0.3-0.5-0.6-0.8-0.8c-0.5-0.5-1-1-1.6-1.5c-0.5-0.4-1.1-0.9-1.7-1.3 C1106.5,358.8,1105.8,358.4,1105,358z"
})));

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M797.3,437c0,0-70.7,14-38.8,23.1c42.1,10.1,94.7-18.9,70-22.6C800.7,433.1,805.6,441.3,797.3,437z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M842.5,308.7h7.7c0,0-6.1,34.5-14.5,32.1S833.4,311.4,842.5,308.7z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "#AF734A",
  d: "M841.4,314.6c0,0,4.7-0.9,2.8-5.1c-1.9-4.1-4.4-2.5-4.4-2.5h-5.1C834.8,307,836.4,315.2,841.4,314.6z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E0D01",
  d: "M812.8,443.7v0.7c0,0.9,0.7,1.6,1.6,1.6h3.8c0.9,0,1.6-0.7,1.6-1.6v-1.3c0-1-0.9-1.8-1.9-1.6l-3.8,0.6 C813.4,442.2,812.8,442.9,812.8,443.7z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E0D01",
  d: "M798.8,442.9l0,1.2c0,1,0.9,1.7,1.9,1.5l4.1-0.8c0.8-0.2,1.4-1,1.3-1.8l-0.2-1.5c-0.2-0.9-1.1-1.5-2-1.3 l-3.9,1C799.3,441.5,798.8,442.2,798.8,442.9z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_20_)",
  d: "M832.5,371.9c0,0-3.8,11.7-5.6,16c-1.8,4.2-1.5,22.8-1.7,23.4s-3,16.8-2.7,18.9 c0.3,2-8.2,4.2-8.6,2c-0.5-2.2-3.6-22.6,0-31.9s-0.8-33.2-0.3-36c0,0,2.7,12.9-1.4,24.7s-2.7,19-3.5,23.9 c-0.8,4.9-0.8,14.9-0.8,17c0,2-7.5,0.8-7.5,0.8s-3.6-28.6,0-41.3c3.6-12.7,2.7-15.7,3.9-26.7C805.6,351.5,833.9,351.6,832.5,371.9 z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_21_)",
  d: "M807.3,272.9c0,0-11.8,1.9-7.5,16.2c4.2,14.3,12,18.4,6.8,30.5c-5,11.5-6.4,11.4-5.9,21.9 c0.4,7.9,2.4,17,2.6,23.2c0.1,2.4,1.5,4.6,3.8,5.6c3.4,1.5,9.3,3.1,18.7,2.4c7.2-0.5,10-3.2,9.9-10.4c-0.1-9.2,0.9-20.8-2.1-29.5 c-3.7-10.7-0.3-12.3-0.3-12.3s5,3.3,9.4-5.5c0,0-1.3-6.4-3.6-5.5c-2.4,0.9-1.6,1.4-1.6,1.4s-6.8-27.5-6.9-31.8 S815.3,270.3,807.3,272.9z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "#AF734A",
  d: "M839.8,251.1c0,0,7.8-6.5,9.4-6.8s6.2-1.4,6.9-2c0.7-0.6,3.2,0.3,0,1.7s-6.5,5.3-2.6,5 c3.9-0.3,6.3,2.1,1.1,2.2c-5.2,0.1-8.3-0.2-9.5,0.9c-1.2,1-5.3,3.7-5.3,3.7V251.1z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E8778",
  d: "M822.3,272.1l20.2-16.2c0,0-0.6-6.5-3.8-5.3c-3.1,1.2-23.7,14.7-23.7,14.7L822.3,272.1z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "#AF734A",
  d: "M826.2,245.3c0,0,5,16.5-3.8,18.2C813.6,265.2,816.4,243.2,826.2,245.3z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M823.6,242.6l-0.9,32.6c0,0-7.2,3.9-7.7,8.9s2.9,15.9-4.8,16.7s-16.9,2.5-16.5-1.7s3.1-32.4,6-35.6c2.8-3.2,3-18.1,3-18.5 S823.6,242.6,823.6,242.6z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0A5449",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M820.7,293.5 c0,0,6.3,13.5,6.9,16c0.6,2.5,1.6,9.3,5.5,11"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "#261001",
  d: "M809.1,429.2c0.1-0.6-0.4-1.1-1-1c-2.6,0.7-6.5,1.8-7.5,1c-1.1-0.9-1.6,9.1-1.7,13.3 c0,1.3,0.4,1.9,1.7,1.8c1.6-0.1,5.6-1.3,8.3-3c1-0.6,2.1-1.1,3.2-1.4l3.5-1.1c0,0,1.9-4.8-6.5-6.8 C809.2,432,808.7,430.7,809.1,429.2z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  fill: "#3D1900",
  d: "M831.2,434.6c0,0,3.3,2.3,0.5,5.1c-2.8,2.8-7.6,2.8-10.1,4.5c-1.8,1.2-5.5,0.7-7.5,0.3 c-0.8-0.2-1.3-0.8-1.3-1.6v-11c0-0.8,0.6-1.5,1.4-1.6l7.2-0.9c0.9-0.1,1.7,0.6,1.8,1.5c0.1,1.1,0.1,2.5-0.2,3.4 C822.4,435.8,827.9,433.5,831.2,434.6z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_22_)",
  d: "M831.8,245.3h-11.4c-0.4,0-0.7,0.1-1,0.3c-1.8,1.1-8.7,5.2-19,5.1c-0.9,0-1.7-0.7-1.9-1.6 c-0.7-4.5-1.4-17.4,12.2-17.8c10.8-0.3,14.7,5.2,16.1,9C827.6,242.6,829.4,244.5,831.8,245.3L831.8,245.3z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M818.5,246.3c0,0-4.1,12.5-16.7,11.9c0,0-4.8-2-3-7.5l3,0c0,0-0.3,5.6,4.9,2.9c5.2-2.7,5.2-4.6,5.2-4.6 L818.5,246.3z"
});

var _ref72 = /*#__PURE__*/React.createElement("g", {
  className: "tree-svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M412.2,147.7c0,0-13.3-16-42.6,58.1S407.4,340,407.4,340s81-61.2,54.3-130.5S412.2,147.7,412.2,147.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "rgba(204, 204, 204, .5)",
  d: "M409.5,321.3c-0.2,4.9-0.7,9.6-1.1,14.4L407,350c-0.4,4.7-0.8,9.4-0.8,14.1c0,2.3,0.1,4.7,0.5,7c0.2,1.1,0.4,2.3,0.9,3.3 c0.4,1.1,1,2.1,2,2.9c-0.6-0.2-1.1-0.5-1.6-0.9c-0.5-0.4-0.9-0.9-1.3-1.4c-0.8-1-1.3-2.2-1.8-3.4c-0.9-2.4-1.4-4.8-1.7-7.3 c-0.6-4.9-0.5-9.8-0.1-14.7c0.4-4.8,1.2-9.6,2.3-14.4C406.4,330.5,407.6,325.9,409.5,321.3z"
}));

var _ref73 = /*#__PURE__*/React.createElement("g", {
  className: "tree-svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M1227,222.6c0,0-8.7-10.5-28,38.1c-19.2,48.6,24.8,88.1,24.8,88.1s53.1-40.2,35.6-85.6 C1242.1,217.7,1227,222.6,1227,222.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "rgba(204, 204, 204, .5)",
  d: "M1225.3,336.6c0.1,3.3,0,6.4-0.2,9.5c-0.2,3.1-0.5,6.2-0.7,9.3c-0.3,3.1-0.6,6.1-0.7,9.2c-0.1,1.5-0.1,3,0.1,4.5 c0.1,1.5,0.4,2.9,1.5,4.2c-0.8-0.2-1.5-0.8-2.1-1.4c-0.3-0.3-0.5-0.7-0.8-1.1c-0.2-0.4-0.4-0.8-0.6-1.1c-0.7-1.6-1.1-3.2-1.3-4.8 c-0.5-3.3-0.5-6.5-0.2-9.7c0.3-3.2,0.8-6.4,1.6-9.5C1222.8,342.5,1223.8,339.5,1225.3,336.6z"
}));

var SvgCover = function SvgCover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1381 491.8",
    enableBackground: "new 0 0 1381 491.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1085.5212,
    y1: 265.5269,
    x2: 1217.2612,
    y2: 233.3077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005A63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    style: {
      stopColor: "#02646E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4162,
    style: {
      stopColor: "#087D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    style: {
      stopColor: "#11A7B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7761,
    style: {
      stopColor: "#11A9BB"
    }
  })), _ref4, _ref5), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 833.2405,
    y1: 277.7011,
    x2: 906.7769,
    y2: 277.7011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref6, _ref7), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 871.4378,
    y1: 286.2391,
    x2: 920.7457,
    y2: 286.2391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref8, _ref9), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 865.9459,
    y1: 335.4779,
    x2: 906.7769,
    y2: 335.4779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    style: {
      stopColor: "#ADB0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED4D8"
    }
  })), _ref10, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 868.9612,
    y1: 354.4826,
    x2: 904.771,
    y2: 354.4826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#666666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    style: {
      stopColor: "#949799"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED4D8"
    }
  })), _ref11)), /*#__PURE__*/React.createElement("g", {
    className: "phone-svg"
  }, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, /*#__PURE__*/React.createElement("g", {
    className: "phone-svg__box"
  }, _ref25, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 891.5461,
    y1: 191.5447,
    x2: 885.9174,
    y2: 227.6576,
    gradientTransform: "matrix(-1 0 0 1 1826.2723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref26), /*#__PURE__*/React.createElement("g", {
    className: "phone-svg__box"
  }, _ref27, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 867.8566,
    y1: 246.0434,
    x2: 862.2279,
    y2: 282.1563,
    gradientTransform: "matrix(-1 0 0 1 1826.2723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref28), /*#__PURE__*/React.createElement("g", {
    className: "phone-svg__box"
  }, _ref29, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 895.3436,
    y1: 230.8915,
    x2: 889.715,
    y2: 267.0043,
    gradientTransform: "matrix(-1 0 0 1 1826.2723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref30), /*#__PURE__*/React.createElement("g", {
    className: "phone-svg__box"
  }, _ref31, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.535,
    y1: 264.7297,
    x2: 831.9064,
    y2: 300.8425,
    gradientTransform: "matrix(-1 0 0 1 1826.2723 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref32), _ref33, /*#__PURE__*/React.createElement("g", {
    className: "phone-svg__illumination"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 810.2138,
    y1: 373.0072,
    x2: 1015.0536,
    y2: 228.1154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.6
    }
  })), _ref34), _ref35), /*#__PURE__*/React.createElement("g", {
    className: "tree-mobile-svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2392,
    y1: 275.9076,
    x2: 159.826,
    y2: 307.481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1238,
    style: {
      stopColor: "#11C3B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3396,
    style: {
      stopColor: "#10A7A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5652,
    style: {
      stopColor: "#0F8288"
    }
  })), _ref36, _ref37), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.4378,
    y1: 294.2391,
    x2: 254.7457,
    y2: 294.2391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2513,
    style: {
      stopColor: "#109F9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#10B9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7969,
    style: {
      stopColor: "#11C8B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref38, _ref39), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.9459,
    y1: 343.4779,
    x2: 240.7769,
    y2: 343.4779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    style: {
      stopColor: "#ADB0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED4D8"
    }
  })), _ref40, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.687,
    y1: 362.5185,
    x2: 239.4851,
    y2: 362.4445
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#666666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    style: {
      stopColor: "#949799"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CED4D8"
    }
  })), _ref41)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.0862,
    y1: 310.4556,
    x2: 785.7072,
    y2: 290.5398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref42, _ref43), /*#__PURE__*/React.createElement("g", {
    className: "tree-mobile-svg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.8288,
    y1: 339.2942,
    x2: 326.2993,
    y2: 346.9026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3754,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5343,
    style: {
      stopColor: "#109F9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    style: {
      stopColor: "#10B9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    style: {
      stopColor: "#11C9B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref44, _ref45), /*#__PURE__*/React.createElement("g", {
    className: "tree-mobile-svg"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.603,
    y1: 329.5556,
    x2: 306.6971,
    y2: 313.5179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    style: {
      stopColor: "#973C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    style: {
      stopColor: "#BD5300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC5C00"
    }
  })), _ref46, _ref47), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1111.3979,
    y1: 337.9416,
    x2: 1136.3927,
    y2: 337.9416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref48, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1143.3973,
    y1: 338.3871,
    x2: 1158.1354,
    y2: 338.3871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref49, _ref50, _ref51, _ref52, _ref53, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1149.4901,
    y1: 367.3064,
    x2: 1166.1418,
    y2: 367.3064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0F8288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#11CEBB"
    }
  })), _ref54), _ref55, /*#__PURE__*/React.createElement("g", {
    className: "woman-svg"
  }, _ref56, _ref57, _ref58, _ref59, _ref60, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 798.1124,
    y1: 393.6848,
    x2: 831.8398,
    y2: 394.5848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    style: {
      stopColor: "#754C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    style: {
      stopColor: "#AF734A"
    }
  })), _ref61, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 798.8226,
    y1: 322.4865,
    x2: 842.5085,
    y2: 322.4865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    style: {
      stopColor: "#0E4B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6674,
    style: {
      stopColor: "#0E8778"
    }
  })), _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 798.2391,
    y1: 240.9523,
    x2: 831.8176,
    y2: 240.9523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#792A00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    style: {
      stopColor: "#973C00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    style: {
      stopColor: "#BD5300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC5C00"
    }
  })), _ref70, _ref71), _ref72, _ref73));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cover.72272b9c.svg";
export { ForwardRef as ReactComponent };